import { thornode } from "./client";

export async function getThornodeStatus() {
  const response = await thornode.get<{ ping: string }>("ping");

  if (response?.data?.ping !== "pong") {
    return false;
  }

  return true;
}
